<div *ngIf="isConversionRunning" class="loader-container">
  <div class="loader"></div>
</div>

<div class="sdds-row" [ngClass]="{'loading':model.loading}">
    <div *ngIf="!isImportAllowed"
        class="sdds-col-max-12 sdds-col-xxlg-12 sdds-col-xlg-12 sdds-col-lg-12 sdds-col-md-12 sdds-col-sm-12 sdds-col-xs-12 sdds-no-padding">
        <div class="sdds-banner">
            <div class="sdds-banner-body">
                {{importNotAllowedReason}}
            </div>
        </div>
    </div>

    <div *ngIf="isImportAllowed && !model.loading"
        class="sdds-col-max-12 sdds-col-xxlg-12 sdds-col-xlg-12 sdds-col-lg-12 sdds-col-md-12 sdds-col-sm-12 sdds-col-xs-12 sdds-no-padding">

        <div class="sdds-row">
            <div *ngIf="needToConvert"
                class="sdds-col-max-12 sdds-col-xxlg-12 sdds-col-xlg-12 sdds-col-lg-12 sdds-col-md-12 sdds-col-sm-12 sdds-col-xs-12 mb-12">
                <div class="sdds-banner sdds-banner-error">
                    <div class="sdds-banner-body">
                        This specification version needs to be converted before uploading a new ODX file. 
                        Press on the button bellow to start the conversion.
                    </div>
                </div>
                <br />
                <button class="sdds-btn sdds-btn-primary" (click)="convertSpecificationVersion()">
                    Convert Specification Version
                </button>
            </div>
            <div *ngIf="!needToConvert"
                class="sdds-col-max-12 sdds-col-xxlg-12 sdds-col-xlg-12 sdds-col-lg-12 sdds-col-md-12 sdds-col-sm-12 sdds-col-xs-12 mb-12">
                <button (click)="updateOdx()" class="sdds-btn sdds-btn-primary sdds-btn-sm mr-5" [disabled]="!canEditCategoryItems()">
                  Import data from ODX File
                </button>
                <app-odx-file-selector-dialog (applySelection)="whenOdxFileSelected($event)"></app-odx-file-selector-dialog>
            </div>
        </div>

        <ng-container *ngIf="odxUpdateAffectedCategoryItem">
            <app-import-preview [odxUpdateAffectedCategoryItem]="odxUpdateAffectedCategoryItem"></app-import-preview>
        </ng-container>
    </div>
</div>
